import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { CentralizedCategory } from "./Category/Category";
import { CentralizedList } from "./List/List";
import { CentralizedLocation } from "./Location/Location";
import { CentralizedType } from "./Type/Type";
import { CentralizedZone } from "./Zone/Zone";

export const CentralizedShopAndDine = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const [currentAirport] = useLocalStorage("currentAirport", null);

  useEffect(() => {
    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    const thirdSubActiveTab = query.get("thirdSubActiveTab");

    if (query.get("id")) {
      return;
    }

    if (!activeTab) {
      navigate(`/centralized/centralizedShopAndDine/?activeTab=centralizedType`, {
        replace: true,
      });
    } else {
      if (activeTab === "shop") {
        const defaultSubActiveTab = "centralizedShopCategoriesPageContent";

        const effectiveSubActiveTab = subActiveTab ?? defaultSubActiveTab;

        navigate(`/centralized/centralizedShopAndDine/?activeTab=shop&subActiveTab=${effectiveSubActiveTab}`, {
          replace: true,
        });
      }

      if (activeTab === "dine") {
        const defaultSubActiveTab = "centralizedDineCategoriesPageContent";

        const effectiveSubActiveTab = subActiveTab ?? defaultSubActiveTab;

        navigate(`/centralized/centralizedShopAndDine/?activeTab=dine&subActiveTab=${effectiveSubActiveTab}`, {
          replace: true,
        });
      }

      if (activeTab === "services") {
        const defaultSubActiveTab = "centralizedServicesCategoriesPageContent";

        const effectiveSubActiveTab = subActiveTab ?? defaultSubActiveTab;

        navigate(`/centralized/centralizedShopAndDine/?activeTab=services&subActiveTab=${effectiveSubActiveTab}`, {
          replace: true,
        });
      }

      if (activeTab === "zone") {
        const defaultSubActiveTab = "centralizedZonePublic";

        const effectiveSubActiveTab = subActiveTab ?? defaultSubActiveTab;

        navigate(`/centralized/centralizedShopAndDine/?activeTab=zone&subActiveTab=${effectiveSubActiveTab}`, {
          replace: true,
        });
      }
    }
  }, [query.get("activeTab"), query.get("subActiveTab"), query.get("thirdSubActiveTab")]);

  const tabItems = [
    // {
    //   label: "Brands",
    //   key: "centralizedBrands",
    //   children: <CentralizedBrands />,
    // },
    // {
    //   label: "Data Classification",
    //   key: "centralizedDataClassification",
    //   children: <CentralizedClassification />,
    // },
    // {
    //   label: "Tags",
    //   key: "centralizedTags",
    //   children: <CentralizedTags />,
    // },
    // {
    //   label: "Redirect URL",
    //   key: "centralizedRedirectUrl",
    //   children: <CentralizedRedirect />,
    // },
    // {
    //   label: "Source",
    //   key: "centralizedSource",
    //   children: <CentralizedSource />,
    // },
    {
      label: "Type",
      key: "centralizedType",
      children: <CentralizedType />,
    },
    {
      label: "Category",
      key: "centralizedCategory",
      children: <CentralizedCategory />,
    },
    // {
    //   label: "Sub Category",
    //   key: "centralizedSubCategory",
    //   children: <CentralizedSubCategory />,
    // },
    {
      label: "List",
      key: "centralizedList",
      children: <CentralizedList />,
    },
    {
      label: "Location",
      key: "centralizedLocation",
      children: <CentralizedLocation />,
    },
    {
      label: "Zone",
      key: "zone",
      children: <CentralizedZone />,
    },
  ];

  const handleShopDine = (subActiveTab: any, activeTab: any) => {
    if (subActiveTab === "centralizedLandingPageContent") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedLandingPageContent/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Page Content
        </Button>
      );
    }
    if (subActiveTab === "centralizedZonePublic") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/zone/centralizedZonePublic/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Zone Public
        </Button>
      );
    }
    if (subActiveTab === "centralizedZonePassenger") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/zone/centralizedZonePassenger/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Zone Passenger
        </Button>
      );
    }
    if (subActiveTab === "centralizedZoneLevels") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/zone/centralizedZoneLevels/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Zone Level
        </Button>
      );
    }
    if (subActiveTab === "centralizedShopListPageContent") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/shop/centralizedShopListPageContent/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add List Content
        </Button>
      );
    }

    if (subActiveTab === "centralizedDineListPageContent") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/dine/centralizedDineListPageContent/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add List Content
        </Button>
      );
    }

    if (subActiveTab === "centralizedServicesListPageContent") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/services/centralizedServicesListPageContent/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add List Content
        </Button>
      );
    }

    if (activeTab === "centralizedBrands") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedBrands/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Brands
        </Button>
      );
    }
    if (activeTab === "centralizedDataClassification") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedDataClassification/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Data Classification
        </Button>
      );
    }
    if (activeTab === "centralizedType") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedType/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Type
        </Button>
      );
    }
    if (activeTab === "centralizedCategory") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedCategory/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Category
        </Button>
      );
    }

    if (activeTab === "centralizedSubCategory") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedSubCategory/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Sub Category
        </Button>
      );
    }
    if (activeTab === "centralizedList") {
      return (
        <Button
          onClick={() => {
            navigate(`/centralized/centralizedShopAndDine/centralizedList/add?listType=${query.get("subActiveTab")}`);
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add List
        </Button>
      );
    }
    if (activeTab === "centralizedTags") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedTags/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Tags
        </Button>
      );
    }
    if (activeTab === "centralizedSource") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedSource/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Source
        </Button>
      );
    }
    if (activeTab === "centralizedLocation") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedLocation/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Location
        </Button>
      );
    }
    if (activeTab === "centralizedRedirectUrl") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedShopAndDine/centralizedRedirectUrl/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Redirect URL
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title="Shop & Dine"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleShopDine(query.get("subActiveTab"), query.get("activeTab"))}
      // airportText={`Airport Specific Content`}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={tabItems}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      />
    </ContentWrapper>
  );
};
